import { Outlet } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const ClaimsLayout = () => {
    return (
        <>
            <Box sx={{ display: 'flex', gap: 2, pb: 1 }}>
                <Typography variant="h6" gutterBottom>Suchaufträge</Typography>
            </Box>
            <Outlet />
        </>
    );
};

export default ClaimsLayout;
